// Webpack substitutes each `process.env.VUE_APP_*` literally, so every key read here
// must exist in `.env` at build time or the bundle keeps an undefined `process` reference.
const buildTime = {
  VUE_APP_APP_NAME: process.env.VUE_APP_APP_NAME,
  VUE_APP_COUNTRY: process.env.VUE_APP_COUNTRY,
  VUE_APP_VERSION: process.env.VUE_APP_VERSION,
  VUE_APP_AUTH_SMART: process.env.VUE_APP_AUTH_SMART,
  VUE_APP_BACKEND: process.env.VUE_APP_BACKEND,
  VUE_APP_BACKEND_SMART: process.env.VUE_APP_BACKEND_SMART,
  VUE_APP_COLLAB_API: process.env.VUE_APP_COLLAB_API,
  VUE_APP_SMARTSCAN_API: process.env.VUE_APP_SMARTSCAN_API,
  VUE_APP_SMARTCOLLAB_URL: process.env.VUE_APP_SMARTCOLLAB_URL,
  VUE_APP_FIREBASE_API_KEY: process.env.VUE_APP_FIREBASE_API_KEY,
  VUE_APP_FIREBASE_AUTH_DOMAIN: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  VUE_APP_FIREBASE_DATABASE_URL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  VUE_APP_FIREBASE_PROJECT_ID: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  VUE_APP_FIREBASE_STORAGE_BUCKET: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  VUE_APP_FIREBASE_MESSAGING_SENDER_ID: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  VUE_APP_FIREBASE_APP_ID: process.env.VUE_APP_FIREBASE_APP_ID,
  VUE_APP_MEASUREMENT_ID: process.env.VUE_APP_MEASUREMENT_ID,
  VUE_APP_ENABLE_VUEX_LOGGER: process.env.VUE_APP_ENABLE_VUEX_LOGGER,
  VUE_APP_I18N_LOCALE: process.env.VUE_APP_I18N_LOCALE,
  VUE_APP_I18N_FALLBACK_LOCALE: process.env.VUE_APP_I18N_FALLBACK_LOCALE
}

export const env = new Proxy({}, {
  get: (target, name) => window.__ENV__?.[name] || buildTime[name] || ''
})
